import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'

import {
  Box, Heading, Image, Link, Text,
} from '@domain-group/suit-theme'

import LogoMarkUrl from './assets/logo-mark.svg'

const AccessDenied = () => {
  const authPayload = useAuth0()
  const { logout } = authPayload

  return (
    <Box
      alignItems="center"
      backgroundColor="whiteGrey"
      height="100vh"
      justifyContent="center"
      padding={['large', 'xxlarge']}
      width="100%"
    >
      <Box alignItems="center" flexDirection="column" justifyContent="center" width={['100%', '400px']}>
        <Image backgroundSize="contain" url={LogoMarkUrl} width={50} height={50} />

        <Heading textProps={{ color: 'bodyFontLightColor', marginTop: 'xlarge' }}>
          Access Denied
        </Heading>

        <Text fontSize="small" marginTop="xlarge">
          Sorry, only admins are allowed past this point.
        </Text>

        <Box alignItems="center" fontSize="xsmall" justifyContent="center" marginTop="xxlarge">
          <Text color="bodyFontLightColor" marginRight="small">Not Loading?</Text>
          <Link onClick={() => logout()}>Try Another Account</Link>
        </Box>
      </Box>
    </Box>
  )
}

export default AccessDenied
